module.exports = __webpack_public_path__ + "img/mtc_anniversary_credit_mae_tao_clinic.e75c1f18.jpg";